<template>
  <div>
    <div class="card">
      <div class="card-header">
        <b-row>
          <b-col>
            Documents
          </b-col>
          <b-col cols="12" md="3" lg="1">
            <b-link v-if="!readonly && requiresDocuments" size="sm" @click="emit( 'documents')">edit</b-link>
            <b-link v-if="!readonly && requiresNotary" size="sm" @click="emit( 'notarize')">edit</b-link>
          </b-col>
        </b-row>
      </div>
      <div class="card-body">
        <div v-if="attachments.length === 0">
          No Documents submitted
        </div>
        <div v-else>
          <AttachmentList :value="attachments" :readonly="true" modalId="review"/>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <b-row>
          <b-col>
            Customer Information
          </b-col>
          <b-col cols="12" md="3" lg="1">
            <b-link v-if="!readonly" size="sm" @click="emit('customer')">edit</b-link>
          </b-col>
        </b-row>
      </div>
      <div class="card-body">
        <b-row>
          <b-col class="font-weight-bold">Customer Name</b-col>
        </b-row>
        <b-row>
          <b-col>First Name: {{profile?.name?.firstName}}</b-col>
          <b-col>Middle Name: {{profile?.name?.middleName}}</b-col>
          <b-col>Last Name: {{profile?.name?.lastName}}</b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col class="font-weight-bold">Contact Information</b-col>
        </b-row>
        <b-row>
          <b-col>Phone Number: {{profile.phone}}</b-col>
          <b-col>Email Address: {{profile.email}}</b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col class="font-weight-bold">Contact Address: </b-col>
        </b-row>
        <b-row>
          <b-col>{{profile?.address?.streetAddress}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{profile?.address?.poBox}}</b-col>
        </b-row>
        <b-row>
          <b-col>
            {{profile?.address?.mnCity ? profile?.address?.mnCity.label : profile?.address?.city}}, {{profile?.address?.state}} {{profile?.address?.zip}}
          </b-col>
        </b-row>
        <b-row v-if="profile?.address?.international">
          <b-col>{{profile?.address?.countryName}}</b-col>
        </b-row>
      </div>
    </div>
    <div class="card" v-if="order?.billingAddress">
      <div class="card-header">Billing Information</div>
      <div class="card-body">
        <b-row>
          <b-col>Billing Address: </b-col>
        </b-row>
        <b-row>
          <b-col>{{order?.billingAddress?.streetAddress}}</b-col>
        </b-row>
        <b-row>
          <b-col>{{order?.billingAddress?.poBox}}</b-col>
        </b-row>
        <b-row>
          <b-col>
            {{order?.billingAddress?.mnCity ? order?.billingAddress?.mnCity.label : order?.billingAddress?.city}}, {{order?.billingAddress?.state}} {{order?.billingAddress?.zip}}
          </b-col>
        </b-row>
        <b-row v-if="order?.billingAddress?.international">
          <b-col>{{order?.billingAddress?.countryName}}</b-col>
        </b-row>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <b-row>
          <b-col>
            Shipping Information
          </b-col>
          <b-col cols="12" md="3" lg="1">
            <b-link v-if="!readonly" size="sm" @click="emit('shipping')">edit</b-link>
          </b-col>
        </b-row>
      </div>
      <div class="card-body">
        <b-row>
          <b-col md="6">
            <b-row>
              <b-col class="font-weight-bold">Shipping Method </b-col>
            </b-row>
            <b-row>
              <b-col>{{order?.shippingType?.method}}</b-col>
            </b-row>
          </b-col>
          <b-col md="6">
            <b-row>
              <b-col class="font-weight-bold">Shipping Address</b-col>
            </b-row>
            <div v-if="order.sameAddress">
              Ship to Contact Address
            </div>
            <div v-if="!order.sameAddress">
              <b-row>
                <b-col>
                  {{order?.shippingAddress?.firstName}} {{order?.shippingAddress?.middleName ? order?.shippingAddress?.middleName + ' ' : ''}}{{order?.shippingAddress?.lastName}}
                </b-col>
              </b-row>
              <b-row>
                <b-col>{{order?.shippingAddress?.streetAddress}}</b-col>
              </b-row>
              <b-row>
                <b-col>{{order?.shippingAddress?.poBox}}</b-col>
              </b-row>
              <b-row>
                <b-col>{{order?.shippingAddress?.mnCity ? order?.shippingAddress?.mnCity.label : order?.shippingAddress?.city}}, {{order?.shippingAddress?.state}} {{order?.shippingAddress?.zip}}</b-col>
              </b-row>
              <b-row v-if="order?.shippingAddress?.international">
                <b-col>{{order?.shippingAddress?.countryName}}</b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>

</template>
<script>


import axiosRetry from 'axios-retry'
import axios from "axios"
import LocalStorageService from "@/common/LocalStorageService";
import address from "address";
import AttachmentList from '@/components/templates/display/AttachmentList.vue';

axiosRetry(axios, { retries: 3,
  retryDelay: axiosRetry.exponentialDelay  });

const localStorageService = LocalStorageService.getService();


export default {
  computed: {
    address() {
      return address
    }
  },
  components: {
    AttachmentList
  },
  data: () => {
    return {
    }
  },
  props: {
    order: [Object],
    profile: [Object],
    attachments: [Array],
    requiresNotary: [Boolean],
    requiresDocuments: [Boolean],
    readonly: {
      default: true,
      type: Boolean
    },
  },
  mounted() {
  },
  methods: {
    emit(tab) {
      this.$emit('change-tab', tab);
    }
  }
}
</script>

<style>
h5 {
  font-weight: bold;
  font-family: inherit;
}
</style>
